window.EasyVue ||= {};
window.EasyVue.easyForm = async payload => {
  const { easyForm } = await import("../src/forms/main");
  easyForm(payload);
};

window.EasyVue.mountAnchorNavBar = async payload => {
  const { mountAnchorNavBar } = await import("../src/forms/main");
  mountAnchorNavBar(payload);
};
